import * as CONST from "../util/app-constants";

const AWS = require("aws-sdk/dist/aws-sdk-react-native");
const AWSIoTData = require("aws-iot-device-sdk");

const axios = require("axios");

AWS.config.region = CONST.REGION; // Region
// AWS.config.credentials = new AWS.CognitoIdentityCredentials({
//   IdentityPoolId: CONST.IDENTITY_POOL_ID,
// });

AWS.config.update({
  accessKeyId: CONST.ACCESS_KEY_ID,
  secretAccessKey: CONST.SECRET_ACCESS_KEY,
});

const docClient = new AWS.DynamoDB.DocumentClient();

const AWSLambda = new AWS.Lambda({
  region: CONST.REGION,
  apiVersion: "2015-03-31",
});

//
// Create a client id to use when connecting to AWS IoT.
//
const clientId = "sym-heartbeat-" + Math.floor(Math.random() * 100000 + 1);

export function getThresholdData(deviceID) {
  const promiseForGetThresholdData = new Promise(function (resolve, reject) {
    const pullParams = {
      FunctionName: CONST.GET_THRESHOLDS_DATA,
      InvocationType: "RequestResponse",
      LogType: "None",
      Payload: `{"deviceID" : "${deviceID}"}`,
    };

    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        resolve(JSON.parse(data.Payload));
      }
    });
  });

  return promiseForGetThresholdData;
}

export function updateThresholdsData(deviceID, thresholdsToUpdate) {
  const promiseForUpdateThresholdsData = new Promise(function (
    resolve,
    reject
  ) {
    const pullParams = {
      FunctionName: CONST.UPDATE_THRESHOLDS_DATA,
      InvocationType: "RequestResponse",
      LogType: "None",
      Payload: `{"deviceID" : "${deviceID}","thresholds" : ${JSON.stringify(
        thresholdsToUpdate
      )}}`,
    };

    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        resolve(data.Payload);
      }
    });
  });

  return promiseForUpdateThresholdsData;
}

//
// Create the AWS IoT device object.  Note that the credentials must be
// initialized with empty strings; when we successfully authenticate to
// the Cognito Identity Pool, the credentials will be dynamically updated.
//
let mqttClient;

export function mqttClientConnect() {
  mqttClient = AWSIoTData.device({
    //
    // Set the AWS region we will operate in.
    //
    region: AWS.config.region,
    //
    ////Set the AWS IoT Host Endpoint
    host: CONST.IOT_HOST,
    //
    // Use the clientId created earlier.
    //
    clientId: clientId,
    //
    // Connect via secure WebSocket
    //
    protocol: "wss",
    //
    // Set the maximum reconnect time to 8 seconds; this is a browser application
    // so we don't want to leave the user waiting too long for reconnection after
    // re-connecting to the network/re-opening their laptop/etc...
    //
    maximumReconnectTimeMs: 8000,
    //
    // Enable console debugging information (optional)
    //
    // debug: true,
    //
    // IMPORTANT: the AWS access key ID, secret key, and sesion token must be
    // initialized with empty strings.
    //
    accessKeyId: "",
    secretKey: "",
    sessionToken: "",
  });
}

export function getMqttClient() {
  return mqttClient;
}

export function authenticate() {
  return new Promise((resolve, reject) => {
    AWS.config.credentials.get((err) => {
      if (err) {
        reject(err);
      }

      //
      // Attempt to authenticate to the Cognito Identity Pool.
      // TODO: Note that this example only supports use of a pool which allows unauthenticated identities.
      //
      const cognitoIdentity = new AWS.CognitoIdentity();
      const params = {
        IdentityId: AWS.config.credentials.identityId,
      };
      cognitoIdentity.getCredentialsForIdentity(params, function (err, data) {
        if (!err) {
          //
          // Update our latest AWS credentials; the MQTT client will use these during its next reconnect attempt.
          //
          mqttClient.updateWebSocketCredentials(
            data.Credentials.AccessKeyId,
            data.Credentials.SecretKey,
            data.Credentials.SessionToken
          );

          resolve("Success");
        } else {
          reject(err);
        }
      });
    });
  });
}

const queryToFetchDynamoDBData = (params) => {
  // const docClient = new AWS.DynamoDB.DocumentClient();
  return new Promise((resolve, reject) => {
    docClient.query(params, (err, data) => {
      if (err || data === null) {
        reject(err);
      } // an error occurred
      else {
        resolve(data);
      } // received data
    });
  });
};

const scanToFetchDynamoDBData = (params) => {
  const docClient = new AWS.DynamoDB.DocumentClient();
  return new Promise((resolve, reject) => {
    docClient.scan(params, (err, data) => {
      if (err || data === null) {
        reject(err);
      } // an error occurred
      else {
        resolve(data);
      } // received data
    });
  });
};

export function requestData(maxItems, deviceId, tableName) {
  // TODO: Q1: Map Sensor data to other Charts

  // Forming the DynamoDB Query
  const params = {
    TableName: tableName,
    Limit: maxItems,
    ConsistentRead: false,
    ScanIndexForward: false,
    ExpressionAttributeValues: {
      ":device_id": deviceId,
    },
    KeyConditionExpression: "device_id = :device_id",
    ProjectionExpression:
      "device_id, timestampepoch, distanceH, distanceV, flood_perc, gasECO2, gasTVOC, humidity, temperature, voltage, x, y, z",
  };

  return queryToFetchDynamoDBData(params);
}

export function requestTechOnSiteData(deviceId) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `https://api.senstra.com.au/v1.1/${deviceId}/security-notes?count=50`
      )
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getLocation(deviceId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`https://api.senstra.com.au/v1.1/${deviceId}/location`)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function requestWithoutDeviceId(
  minsBack,
  toTs = new Date().getTime(),
  tableName
) {
  // Generating a string of the last X hours back
  // const minBack = minsBack; // minBack = 20; //Todo change minBack to 20 for production
  // const toTs = new Date().getTime();
  const fromTs = toTs - minsBack * 60 * 1000;

  // TODO: Q1: Map Sensor data to other Charts

  // Forming the DynamoDB Query
  const params = {
    TableName: tableName,
    ConsistentRead: false,
    ScanIndexForward: false,
    FilterExpression: "notificationTimestamp BETWEEN :from_date AND :to_date",
    ExpressionAttributeValues: {
      ":from_date": fromTs,
      ":to_date": toTs,
    },
    ProjectionExpression:
      "deviceID, notificationTimestamp, description, notificationCategory, noticationStatus, notificationType, notificationValue, rsp, sdp, technologyType, accessType, correlationCategory",
  };

  return scanToFetchDynamoDBData(params);
}

export function requestTimedData(minsBack, deviceId, tableName) {
  // Generating a string of the last X hours back
  const minBack = minsBack; // minBack = 20; //Todo change minBack to 20 for production
  const toTs = new Date().getTime();
  const fromTs = toTs - minBack * 60 * 1000;
  // 
  // 
  // TODO: Q1: Map Sensor data to other Charts

  // Forming the DynamoDB Query
  const params = {
    TableName: tableName,
    ConsistentRead: false,
    ScanIndexForward: false,
    ExpressionAttributeValues: {
      ":device_id": deviceId,
      ":from_date": fromTs,
      ":to_date": toTs,
    },
    KeyConditionExpression:
      "device_id = :device_id AND timestampepoch BETWEEN :from_date AND :to_date",
    ProjectionExpression:
      "device_id, timestampepoch, distanceH, distanceV, flood_perc, gasECO2, gasTVOC, humidity, temperature, voltage, x, y, z",
  };

  return queryToFetchDynamoDBData(params);
}

export function getNotifications(page_num, deviceID) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `https://dla8h8bs7g.execute-api.ap-southeast-2.amazonaws.com/v1/${deviceID}/notification`
      )
      .then((data) => {

        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function closeNotification(notificationTimestamp, deviceID) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `https://dla8h8bs7g.execute-api.ap-southeast-2.amazonaws.com/v1/${deviceID}/notification/close?timestamp=${notificationTimestamp}`
      )
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function searchDevices(searchText, pageNumber) {
  return new Promise((resolve, reject) => {
    axios
      .get(`https://api.senstra.com.au/v1.1/search?starts=${searchText}`)
      .then((data) => {

        resolve(data.data);
      })
      .catch((err) => {

      });
  });
}

// TODO - Refactor this code to single function
export function requestNotificationTimedData(minsBack, deviceId, tableName) {
  // Generating a string of the last X hours back
  const minBack = minsBack; // minBack = 20; //Todo change minBack to 20 for production
  const toTs = new Date().getTime();
  const fromTs = toTs - minBack * 60 * 1000;

  // TODO: Q1: Map Sensor data to other Charts

  // Forming the DynamoDB Query
  const params = {
    TableName: tableName,
    ConsistentRead: false,
    ScanIndexForward: false,
    ExpressionAttributeValues: {
      ":deviceID": deviceId,
      ":from_date": fromTs,
      ":to_date": toTs,
    },
    KeyConditionExpression:
      "deviceID = :deviceID AND notificationTimestamp BETWEEN :from_date AND :to_date",
    ProjectionExpression:
      "deviceID, notificationTimestamp, description, notificationCategory, noticationStatus, notificationType, notificationValue",
  };

  return queryToFetchDynamoDBData(params);
}

const updateDynamoDBData = (params) => {
  const docClient = new AWS.DynamoDB.DocumentClient();
  return new Promise((resolve, reject) => {
    docClient.update(params, (err, data) => {
      if (err || data === null) {
        reject(err);
      } // an error occurred
      else {
        resolve(data);
      } // received data
    });
  });
};

export function updateThemeConfiguration(
  userpoolID,
  themeID,
  layout,
  link,
  linkToLogo
) {
  let items;
  if (themeID !== null && layout === null) {
    items = {
      themeID: themeID,
    };
  } else if (themeID === null && layout !== null) {
    items = {
      layoutHeartbeat: layout,
    };
  } else if (link && linkToLogo) {
    items = {
      link: link,
      linkToLogo: linkToLogo,
    };
  } else if (link && !linkToLogo) {
    items = {
      link: link,
    };
  } else if (!link && linkToLogo) {
    items = {
      linkToLogo: linkToLogo,
    };
  }

  let payloadObject = { userpoolID: userpoolID, themeConfig: items };
  const pullParams = {
    FunctionName: CONST.UPDATE_THEME_CONFIGURATION,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: JSON.stringify(payloadObject),
  };
  return new Promise((resolve, reject) => {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

export function getThemeConfiguration(userpoolID) {
  let payloadObject = { userpoolID: userpoolID };
  const pullParams = {
    FunctionName: CONST.GET_THEME_CONFIGURATION,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: JSON.stringify(payloadObject),
  };
  return new Promise((resolve, reject) => {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

export function requestStateWiseDevices(tableName) {
  // Forming the DynamoDB Query
  const params = {
    TableName: tableName,
    ConsistentRead: false,
    ScanIndexForward: false,
    ProjectionExpression: "NSW, NT, QLD, SA, TA, VI, WA",
  };

  return scanToFetchDynamoDBData(params);
}

export function requestAustraliaLocations(tableName) {
  // Forming the DynamoDB Query
  const params = {
    TableName: tableName,
    ConsistentRead: false,
    ScanIndexForward: false,
    ExpressionAttributeNames: {
      "#stateCordinate": "location",
    },
    ProjectionExpression: "#stateCordinate",
  };

  return scanToFetchDynamoDBData(params);
}

export function updateDeviceCount(
  tableName,
  NSWCount,
  WACount,
  NTCount,
  QLDCount,
  SACount,
  VICount,
  TACount
) {
  const params = {
    TableName: tableName,
    Key: {
      state_device: "1000",
    },
    UpdateExpression:
      "set NSW = :NSWCount, WA = :WACount, NT = :NTCount, QLD = :QLDCount, SA = :SACount, VI = :VICount, TA = :TACount",
    ExpressionAttributeValues: {
      ":NSWCount": NSWCount,
      ":WACount": WACount,
      ":NTCount": NTCount,
      ":QLDCount": QLDCount,
      ":SACount": SACount,
      ":VICount": VICount,
      ":TACount": TACount,
    },
    ReturnValues: "UPDATED_NEW",
  };
  return updateDynamoDBData(params);
}

export function getDevicesData(states, mapBounds) {
  let data = {
    MapData: [
      {
        deviceID: "Device 1",
        latitude: -26.397,
        longitude: 137.644,
        isTechOnSite: true,
        numberOfActiveNotifications: 0,
        numberOfClosedNotifications: 0,
      },
      {
        deviceID: "Device 2",
        latitude: -26.397,
        longitude: 138.644,
        isTechOnSite: true,
        numberOfActiveNotifications: 0,
        numberOfClosedNotifications: 0,
      },
      {
        deviceID: "Device 3",
        latitude: -26.397,
        longitude: 139.644,
        isTechOnSite: true,
        numberOfActiveNotifications: 0,
        numberOfClosedNotifications: 0,
      },
      {
        deviceID: "Device 4",
        latitude: -26.397,
        longitude: 140.644,
        isTechOnSite: false,
        numberOfActiveNotifications: 7,
        numberOfClosedNotifications: 8,
      },
      {
        deviceID: "Device 5",
        latitude: -26.397,
        longitude: 141.644,
        isTechOnSite: false,
        numberOfActiveNotifications: 9,
        numberOfClosedNotifications: 10,
      },
      {
        deviceID: "Device 6",
        latitude: -26.397,
        longitude: 142.644,
        isTechOnSite: false,
        numberOfActiveNotifications: 11,
        numberOfClosedNotifications: 12,
      },
    ],
  };

  return new Promise((resolve, reject) => {
    let markers = data.MapData.filter((el) => {
      if (
        el.latitude > mapBounds[0].lat() &&
        el.latitude < mapBounds[1].lat() &&
        el.longitude > mapBounds[0].lng() &&
        el.longitude < mapBounds[1].lng()
      ) {
        return true;
      }
    });

    let numberOfFilteredTechsOnsite = 0;
    let numberOfFilteredActiveNotifications = 0;
    let numberOfFilteredClosedNotifications = 0;

    let numberOfTotalTechsOnsite = 0;
    let numberOfTotalActiveNotifications = 0;
    let numberOfTotalClosedNotifications = 0;

    markers.forEach((el) => {
      if (el.isTechOnSite) {
        numberOfFilteredTechsOnsite++;
      }

      numberOfFilteredActiveNotifications =
        numberOfFilteredActiveNotifications +
        (el.numberOfActiveNotifications > 0 ? 1 : 0);
      numberOfFilteredClosedNotifications =
        numberOfFilteredClosedNotifications +
        (el.numberOfClosedNotifications > 0 ? 1 : 0);
    });

    data.MapData.forEach((el) => {
      if (el.isTechOnSite) {
        numberOfTotalTechsOnsite++;
      }

      numberOfTotalActiveNotifications =
        numberOfTotalActiveNotifications +
        (el.numberOfActiveNotifications > 0 ? 1 : 0);
      numberOfTotalClosedNotifications =
        numberOfTotalClosedNotifications +
        (el.numberOfClosedNotifications > 0 ? 1 : 0);
    });



    resolve(
      JSON.stringify({
        MapData: markers,
        Summary: {
          TotalFilteredDevices: markers.length,
          TotalFilteredTechOnsite: numberOfFilteredTechsOnsite,
          TotalFilteredDevicesWithActiveNotificaion: numberOfFilteredActiveNotifications,
          TotalFilteredDevicesWithClosedNotificaion: numberOfFilteredClosedNotifications,
        },
        MetaData: {
          TotalDevices: 6,
          TotalTechOnsite: numberOfTotalTechsOnsite,
          TotalDevicesWithActiveNotificaion: numberOfTotalActiveNotifications,
          TotalDevicesWithClosedNotificaion: numberOfTotalClosedNotifications,
        },
      })
    );
  });

  //   let payloadObject = { filterStates: states, mapBounds: mapBounds };

  //   const pullParams = {
  //     FunctionName: CONST.DEVICE_DATA_FUNCTION,
  //     InvocationType: 'RequestResponse',
  //     LogType: 'None',
  //     Payload: JSON.stringify(payloadObject)
  //   };

  //   return new Promise((resolve, reject) => {
  //     AWSLambda.invoke(pullParams, function (err, data) {
  //       if (err) {
  //         reject(err);
  //       } else {
  //         // 
  //         resolve(JSON.parse(data.Payload));
  //       }
  //     });
  //   });
}

export function refreshDevicesData() {
  const pullParams = {
    FunctionName: CONST.DEVICE_RAW_DATA_FUNCTION,
    InvocationType: "RequestResponse",
    LogType: "None",
  };

  return new Promise((resolve, reject) => {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve();
      }
    });
  });
}

export function getPitStatusLast7Days(deviceID) {
  const pullParams = {
    FunctionName: CONST.PIT_STATUS_7_DAYS,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: `{"deviceID" : "${deviceID}"}`,
  };

  return new Promise((resolve, reject) => {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

export function getPitStatusLast30Days(deviceID) {
  const pullParams = {
    FunctionName: CONST.PIT_STATUS_30_DAYS,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: `{"deviceID" : "${deviceID}"}`,
  };

  return new Promise((resolve, reject) => {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

export function getTechStatusLast7Days(deviceID) {
  const pullParams = {
    FunctionName: CONST.TECH_STATUS_7_DAYS,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: `{"deviceID" : "${deviceID}"}`,
  };

  return new Promise((resolve, reject) => {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

export function getTechStatusLast30Days(deviceID) {
  const pullParams = {
    FunctionName: CONST.TECH_STATUS_30_DAYS,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: `{"deviceID" : "${deviceID}"}`,
  };

  return new Promise((resolve, reject) => {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

export function getFilteredRecord(data) {
  switch (data) {
    case "Latest 10 Records": {
      return 10;
    }
    case "1 Day": {
      return 1;
    }
    case "7 Days": {
      return 7;
    }
    case "14 Days": {
      return 14;
    }
    case "28 Days": {
      return 28;
    }
    default:
      return 10;
  }
}

export function getCurrentStatusDetails(deviceID) {
  const pullParams = {
    FunctionName: CONST.GET_CURRENT_STATUS,
    InvocationType: "RequestResponse",
    LogType: "None",
    Payload: `{"deviceID" : "${deviceID}"}`,
  };

  return new Promise((resolve, reject) => {
    AWSLambda.invoke(pullParams, function (err, data) {
      if (err) {
        reject(err);
      } else {
        // 
        resolve(JSON.parse(data.Payload));
      }
    });
  });
}

export function getPitStatus(deviceID, numberOfRecordsToFetch) {
  return new Promise((resolve, reject) => {
    const filter = getFilteredRecord(numberOfRecordsToFetch);
    let url;
    if (filter === 10) {
      url = `notifications?count=${filter}`;
    } else {
      url = `notifications?dd=${filter}`;
    }
    axios
      .get(`https://api.senstra.com.au/dev/${deviceID}/${url}&event=security`)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getNumberOfPitStatus(numberOfRecords, deviceID) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `https://dla8h8bs7g.execute-api.ap-southeast-2.amazonaws.com/v1/${deviceID}/security?${numberOfRecords}`
      )
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getPitDepth(deviceID) {
  return new Promise((resolve, reject) => {
    axios
      .get(`https://api.senstra.com.au/v1.1/${deviceID}/pit-depth`)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function setDepthOfPit(deviceID, pitDepth) {
  return new Promise((resolve, reject) => {
    axios
      .put(`https://api.senstra.com.au/v1.1/${deviceID}/pit-depth`, {
        pitDepth: pitDepth,
      })
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getAllConfiguration(deviceID) {
  return new Promise((resolve, reject) => {
    axios
      .get(`https://api.senstra.com.au/v1.1/${deviceID}/shadow`)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function setAllConfiguration(deviceID, data) {
  return new Promise((resolve, reject) => {
    axios
      .patch(`https://api.senstra.com.au/v1.1/${deviceID}/shadow`, data)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getPitWarningLevel(deviceID) {
  return new Promise((resolve, reject) => {
    axios
      .get(`https://api.senstra.com.au/v1.1/${deviceID}`)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getMultipleReadingsFromAllSensors(
  fromTimestamp,
  toTimestamp,
  nodeId
) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `https://dpsbfcyz77.execute-api.ap-southeast-2.amazonaws.com/v2/${nodeId}/current?start=${fromTimestamp}&end=${toTimestamp}`
      )
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {

        reject(err);
      });
  });
}

export function getLastNRecordsFromAllSensors(
  numberOfRecordsToFetch,
  nodeId,
  sensorType
) {
  return new Promise((resolve, reject) => {
    const filter = getFilteredRecord(numberOfRecordsToFetch);
    let url;
    if (filter === 10) {
      url = `current?count=${filter}&&columns=${sensorType}`;
    } else {
      url = `current?dd=${filter}&&columns=${sensorType}`;
    }
    axios
      .get(`https://api.senstra.com.au/v1.1/${nodeId}/${url}`)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}


export function getNodeVitals(
) {
  return new Promise((resolve, reject) => {
    axios
      .get(`https://api.senstra.com.au/dev/nodes/catalogue?categories=vitals`)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getDeviceCatalogue(nodeId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`https://api.senstra.com.au/dev/nodes/catalogue`)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getIndividualNodeVitals(nodeId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`https://api.senstra.com.au/dev/${nodeId}/vitals/current`)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}


export function extractDataForPdf(nodeId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`https://api.senstra.com.au/dev/reports/csv?category=sensor&nodes=${nodeId}&from=1614039957 `)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}


export function alertsModificationData(nodeId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`https://api.senstra.com.au/dev/notifications?count=300`)
      .then((data) => {
        resolve(data.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function updateAlertStatus(data, nodeId) {
  return new Promise((resolve, reject) => {
    axios
      .patch(`https://api.senstra.com.au/dev/${nodeId}/notifications`, data)
      .then((item) => {
        resolve(item);
      })
      .catch((err) => {
        reject(err);
      });
  });
} 


// WEBPACK FOOTER //
// ./util/aws-manager.js